import React from "react";
import IconComponent from "../Icons/IconComponent";
const ImportFile = ({ disabled, value, access, thumbnail, onAddFiles, onOpenModal, onDeleteFiles }) => {
    let fileInput = null;

    const getAccess = () => {
        if (!access || access === "all") {return null;}

        const hasImage = access.includes("image");
        const hasVideo = access.includes("video");
        const hastPDF = access.includes("pdf");

        let filterValue = "";

        if (hasImage && !hasVideo && !hastPDF) {
            filterValue = "image/jpeg, image/png, image/svg+xml";
        }
        if (!hasImage && hasVideo && !hastPDF) {
            filterValue = "video/*";
        }
        if (!hasImage && !hasVideo && hastPDF) {
            filterValue = "application/pdf";
        }
        if (hasImage && hasVideo && !hastPDF) {
            filterValue = "image/jpeg, image/png, image/svg+xml,video/*";
        }
        if (hasImage && hasVideo && hastPDF) {
            filterValue = "image/jpeg, image/png, image/svg+xml,video/*,application/pdf";
        }
        return filterValue;
    };
    return <>
        {thumbnail ? <div className="InputImage"
            style={{
                marginRight: "-10px",
                background: "url(" + thumbnail + ") var(--input-background) 50% / cover no-repeat"
            }}/> : null}
        <div className="importFileField">
            <input name={"importFile"}
                ref={(input) => { fileInput = input; }}
                type="file"
                accept={getAccess()}
                onChange={ (e) => {
                    const allowed = [];
                    for (let i = 0; i < e.target.files.length; i++) {
                        const strFile = e.target.files[i];
                        const extension = strFile.name.split(".").pop().toLowerCase();
                        if (!access || access === "all") {
                            allowed.push(strFile);
                        }
                        else if (access.includes("image") && ["jpg", "jpeg", "png", "svg"].includes(extension)) {
                            allowed.push(strFile);
                        }
                        else if (strFile.type.indexOf("video") > -1 && access.includes("video")) {
                            allowed.push(strFile);
                        }
                        else if (strFile.type.indexOf("pdf") > -1 && access.includes("pdf")) {
                            allowed.push(strFile);
                        }
                    }
                    if (onAddFiles && allowed.length > 0) {
                        onAddFiles(allowed);
                    }
                }
                }
                style={{ display: "none" }}
                multiple
            />
            <span style={{ width: "0px" }}/>
            <span style={{ color: disabled ? "var(--grey-light)" : "var(--carbone)" }}>{value}</span>
            <span style={{ flexGrow: "1" }}/>
            {onAddFiles ?
                <button type='button' className="button-round-secondary-icon-without-text" style={{ border: "transparent" }}
                    onClick={() => {if (!disabled) {fileInput.click();}}}>
                    <IconComponent nameIcon="upload" color="carbone" dimensions="24"/>
                </button> : null }
            {
                onOpenModal ? <button type='button' className="button-round-secondary-icon-without-text" style={{ border: "transparent" }}
                    onClick={() => {if (!disabled) {onOpenModal();}}}>
                    <IconComponent nameIcon="folder" color="carbone" dimensions="24"/>
                </button> : null
            }
            {
                onDeleteFiles ? <button type='button' className="button-round-secondary-icon-without-text"
                    disabled={disabled || !value}
                    style={{ border: "transparent" }}
                    onClick={() => {
                        if (!disabled && value) {
                            onDeleteFiles();
                        }
                    }}>
                    <IconComponent nameIcon="trash" color="carbone"/>
                </button> : null
            }
            <span style={{ width: "0px" }}/>
        </div></>;
};
export default ImportFile;
